// extracted by mini-css-extract-plugin
export default {"tabsContainer":"style_tabsContainer__mwIKn","tab":"style_tab__QFsbc","btn":"style_btn__Aot9g","active":"style_active__3Mgw5","content":"style_content__dGizF"};